/**
 * Factory for Device Manager Connection Timeout error
 *
 * @alias TmrDeviceManagerConnectionTimeoutError
 * @type {ngFactory}
 */
export const factory = [
  'TmrDeviceManagerConnectionTimeoutError',
  /*@ngInject*/ (TmrError, DeviceManager) =>
    class TmrDeviceManagerConnectionTimeoutError extends TmrError {
      constructor(message = 'ERROR.DEVICEMANAGERCONNECTIONTIMEOUT', ...params) {
        super(message, ...params)
      }

      get substitutions() {
        return {
          address: `${DeviceManager.getProtocol()}://${DeviceManager.getBasePath()}`,
        }
      }
    },
]
